<template>
   <ul class="results-list">
      <li
         v-if="searchQuery"
         class="class create"
         @click="emit('creatClass', searchQuery)"
      >
         <span class="title">{{ searchQuery }}</span>
         <span class="label note">Create Class</span>
      </li>
      <span class="label grey">{{ label }}</span>
      <li
         v-for="(result, i) in results"
         role="button"
         tabindex="0"
         :class="[
            'class',
            {
               assigned: checkAssigned(result),
            },
         ]"
         :key="i"
         @click="emit('onAssign', result?.id)"
      >
         <span class="title">{{ result?.title }}</span>
         <span class="label assigned-note">assigned</span>
      </li>
      <li v-if="!results.length" class="class no-results">
         <span class="title">No Results</span>
      </li>
   </ul>
</template>
<script setup lang="ts">
import type { Classroom } from "~/types/classroom";

const emit = defineEmits<{
   (e: "onAssign", id: number | undefined): void;
   (e: "creatClass", name: string): void;
}>();
const route = useRoute();
const props = withDefaults(
   defineProps<{
      searchQuery?: string;
      label: string;
      targetId?: number | null;
      results: Classroom.Simplified[];
      assignedClasses: Classroom.Simplified[];
   }>(),
   { searchQuery: "", targetId: null },
);

const checkAssigned = (result: Classroom.Simplified): boolean => {
   return props.assignedClasses?.some((cls) => cls.id == result.id) ?? false;
};
</script>

<style lang="scss">
ul.results-list {
   margin: 0;
   position: relative;
   z-index: 10;
   span.label {
      margin: 0 0 pad(1);
   }
   li.class {
      padding: pad(1) pad(2);
      @include flex(row, center, space-between);
      cursor: pointer;
      transition: tran(background-color, 0.1s);
      &.create {
         margin-bottom: pad(2);
      }
      span {
         display: block;
         &.assigned-note {
            padding: 0;
            margin: 0;
            display: none;
         }
         &.note {
            padding: 0;
            margin: 0;
         }
      }
      &:hover {
         background-color: rgba($blue-lt, 0.9);
      }
      &.assigned,
      &.no-results {
         pointer-events: none;
         color: $copy-lt;
         span.assigned-note {
            display: block;
         }
      }
   }
}
</style>
